import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { ProjectService } from '../../../api/services/project.services';
import { BomLine, BomLineInput, BomLinesRequest } from '../../../api/models/bom-line';
import { BomTableService } from '../../bom-table/bom-table.service';
import { Comment } from '../../../api/models/comment';
import { CommentsAdapterService } from '../../comments/comments-adapter.service';
import { ApproverReasonComponent } from '../../comments/approver-reason/approver-reason.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Worksheet } from '../../../api/models/worksheet';
import { Router } from '@angular/router';
import { ApprovalService } from '../../../api/services/approval.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../api/services/auth.service';
import { OrderCreateComponent } from '../../order-create/order-create.component';
import { OrderService } from '../../services/order.service';
import { MarketService } from '../../../api/services/market.service';
import { PurchasePlan } from '../../../api/models/purchase-plan';
import { PreferencesService } from '../../../api/services/preferences.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RoleRequest } from '../../../api/models/role-assignment-map';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { UserService } from '../../../api/services/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmationModalComponent } from '../../confirmation-modal/confirmation-modal.component';
import { ProductAliasService } from '../../../api/services/product-alias.service';
import { DeleteModalComponent } from '../../delete-modal/delete-modal.component';
import { Location } from '@angular/common';
import { QuoteRequest } from '../../../api/models/quote-request';
import { OrderDetail } from '../../../api/models/order-detail';
import { Subscription } from 'rxjs';
import { Market } from '../../../api/models/market-model';

@Component({
  selector: 'app-worksheet',
  templateUrl: './worksheet.component.html',
  styleUrls: ['./worksheet.component.scss'],
  providers: [BomTableService]
})
export class WorksheetComponent implements OnInit {
  loading: boolean = false;
  showBomTable: boolean = false;
  private VERIZON_DATE_FORMAT_REGEX = '(0[1-9]|1[012])/(0[1-9]|[12][0-9]|3[01])/([0-9]{2})';
  worksheetBomData = new Subject<BomLine[]>();
  quoteUpdateComplete = new Subject<boolean>();
  worksheet: Worksheet;

  comments: Comment[];

  showResubmitButton = false;
  submittedForApproval = false;
  submittingApproval = false;
  canDeleteItems = false;
  canEditWorksheetInfo: boolean;
  tesscoReviewSubmitted = false;

  bomId: string;

  canApproveDeny: boolean;

  canSubmitQuote = false;

  isVerizonClient = false;

  isStandardClient = false;

  edit = false;

  bomLines: BomLine[];

  errorMessage: string[] = [];
  worksheetMessages: string;

  accountNumber: string;
  selectedPurchasePlan: PurchasePlan;
  allowWorksheetContinue: boolean = true;
  confirmTerms: boolean = false;
  noPurchasePlan: boolean = true;
  verizonExpanded: boolean = false;
  specialSelected: string;
  verizonFieldsForm: FormGroup;
  projectFields: any;
  nonEditableProjectFields: any = {};
  roleRequest: RoleRequest;
  isTesscoAdmin: boolean = false;
  verizonFields: any;
  verizonOptions = ['Original', 'Revised', 'Supplement', 'Cancel'];
  equoteResponse = false;
  saveButtonEvent = false;

  canRetractWorksheet: boolean = false;
  worksheets: string[] = [];
  quoteResponse: OrderDetail;

  bomLinesPOLineNumberDetails: BomLineInput[] = [];

  orderServiceDubscription: Subscription;
  purchasePlanFlag: boolean = false;

  @Input() worksheetId: string;
  @Input() market: Market;
  @Input()
  set newBomLines(obs: Observable<BomLine[]>) {
    obs.switchMap(lines => 
      {
        const bomLineRequest = new BomLinesRequest();
        bomLineRequest.bomId = this.bomId;
        bomLineRequest.worksheetId = this.worksheetId;
        bomLineRequest.customerNumber = this.accountNumber;
        bomLineRequest.bomLines = lines;
        return this.bomTableService.addItemsV2(bomLineRequest);
      })
      .switchMap(() => this.projectService.getBomLines(this.bomId))
      .subscribe(data => {
        this.worksheetBomData.next(data);
      });
  }

  @Output() saveEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() editEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private userService: UserService,
    private formBuilder: FormBuilder,
    private projectService: ProjectService,
    private commentsAdapterService: CommentsAdapterService,
    private modalService: NgbModal,
    private bomTableService: BomTableService,
    private router: Router,
    private approvalService: ApprovalService,
    private toastr: ToastrService,
    private authService: AuthService,
    private orderService: OrderService,
    private marketService: MarketService,
    private preferencesService: PreferencesService,
    private productAliasService: ProductAliasService,
    private location: Location
  ) { 
    this.projectService.refreshWorksheet.subscribe(value => {
      if(value){ this.saveChanges(); }
    });
  }

  ngOnInit() {
    this.projectService.getWorksheet(this.worksheetId)
      .subscribe(worksheet => {
      if (this.userService.isMarketPermittedForCurrentUser(worksheet.project.marketId)) {
        this.worksheet = worksheet;
        this.bomId = worksheet.bomId;
        if (this.market) {
          this.accountNumber = this.market.accountNumber;
          this.purchasePlanFlag = this.market.purchasePlanFlag;
          if (this.market.purchasePlanFlag) {
            this.setPurchasePlan(this.accountNumber, this.worksheet.worksheetPurchasePlanCode);
          }
          this.getBomLines();
          this.showBomTable = true;
        }
        this.roleRequest = new RoleRequest('ADMIN_TESSCO', null);
        this.authService.getUserRoles(this.roleRequest).subscribe(roles => {
          this.isTesscoAdmin = roles.getRoleMap('ADMIN_TESSCO');
          this.preferencesService.getPreferences('CUSTOMER', this.worksheet.project.organizationId).subscribe(prefs => {
            this.specialSelected = prefs['special-fields'].Value;
            this.isStandardClient =  prefs['special-fields'].Value === 'Standard';
            if (this.specialSelected === 'Verizon eQuote') {
              this.isVerizonClient = true;
              this.preferencesService.getPreferences('PROJECT', this.worksheet.project.id).subscribe(prefs => {
                if (prefs) {
                  this.nonEditableProjectFields['oracle-project-number'] = prefs['oracle-project-number'] ? prefs['oracle-project-number'].Value : '';
                  this.nonEditableProjectFields['oracle-project-name'] = prefs['oracle-project-name'] ? prefs['oracle-project-name'].Value : '';
                  this.nonEditableProjectFields['project-code'] = prefs['project-code'] ? prefs['project-code'].Value : '';
                  this.nonEditableProjectFields['location-code'] = prefs['location-code'] ? prefs['location-code'].Value : '';
                }
              });
              this.preferencesService.getPreferences('WORKSHEET', this.worksheet.id).subscribe(prefs => {
                this.projectFields = prefs;
                this.setVerizonFieldsFormData();
              });
              this.projectService.canRetractWorksheet(this.worksheetId).subscribe(result => {
                this.canRetractWorksheet = result;
              });
              if (this.worksheet && this.worksheet.isQuoted) {
                this.projectService.getQuoteV2(this.worksheet.id).subscribe(quoteTransaction => {
                  this.quoteResponse = quoteTransaction;
                });
              }
            }else if (this.isStandardClient){
              if (this.worksheet && this.worksheet.isQuoted) {
                this.projectService.getQuoteV2(this.worksheet.id).subscribe(quoteTransaction => {
                  this.quoteResponse = quoteTransaction;
                });
              }
              this.projectService.canRetractWorksheet(this.worksheetId).subscribe(result => {
                this.canRetractWorksheet = result;
              });
            }
          });
          this.isTesscoAdmin ? this.canApproveDeny = true : this.setValueOfCanApproveOrDeny(worksheet);

          this.commentsAdapterService.getCommentsTree(`WORKSHEET~${this.bomId}`, this.isTesscoAdmin).subscribe(comments => this.comments = comments);
        });
        this.authService.getUserRolesInContext(`MARKET~${this.worksheet.project.marketId}`).subscribe(roles => {
          this.canDeleteItems = roles.includes('WORKSHEET_UPDATE');
          this.canEditWorksheetInfo = roles.includes('WORKSHEET_UPDATE');
          this.canSubmitQuote = roles.includes('QUOTE_SUBMIT');
          if (!(this.canDeleteItems && this.canSubmitQuote)) {
            this.authService.getUserRolesInContext(`WORKSHEET~${this.worksheet.id}`).subscribe(roles => {
              this.canDeleteItems = roles.includes('WORKSHEET_UPDATE');
              this.canEditWorksheetInfo = roles.includes('WORKSHEET_UPDATE');
              this.canSubmitQuote = roles.includes('QUOTE_SUBMIT');
            });
          }
        });

      //  this.getBomLines();
        this.canShowResubmitForApprovalButton();
        } else {
          this.worksheet = null;
        }
      }, error => {
        this.errorMessage.push(error.error.message);
      });

      this.orderServiceDubscription =  this.orderService.$newImportedBomLines.subscribe(bomLines => {
        if (bomLines[0].message) {
          this.worksheetMessages = bomLines[0].message;
        }
        this.bomTableService.getBomLines(this.bomId).subscribe(data => {
          this.bomLines = data;
          this.worksheetBomData.next(data);
        });
      });
      this.saveEvent.emit(true);
  }

  private setValueOfCanApproveOrDeny(worksheet: Worksheet) {
    if (worksheet.approvalStatus === 'PENDING_APPROVAL') {
      this.approvalService.getApproval(this.worksheet.approvalId).subscribe(approval => {
        this.canApproveDeny = approval.approvalAllowed;
      });
    }
    if (worksheet.approvalStatusTierTwo === 'PENDING_APPROVAL') {
      this.approvalService.getApproval(this.worksheet.approvalIdTierTwo).subscribe(approval => {
        this.canApproveDeny = approval.approvalAllowed;
      });
    }
  }

  private getBomLines() {
    this.bomTableService.getBomLines(this.bomId)
    .subscribe(data => {
      this.bomLines = data;
      if (!this.bomLines.length) {
        this.edit = true;
        this.editEvent.emit(true);
      }
      this.worksheetBomData.next(data);
      this.showBomTable = true;
    });
  }
  // private getBomLines() {
  //   this.projectService.getOrderSimulation(this.worksheetId).subscribe(data => {
  //     this.orderSimulationData.next(data);
  //   }, error => {
  //     console.log('Error while fetching Order Simulation Data: ', error);
  //   });
  //   this.bomTableService.getBomLines(this.bomId)
  //   .subscribe(data => {
  //     this.bomLines = data;
  //     if (!this.bomLines.length) {
  //       this.edit = true;
  //     }
  //     this.worksheetBomData.next(data);
  //   });
  // }

  setVerizonFieldsFormData() {
    this.projectFields = this.projectFields ? this.projectFields : {};
    let vrznOption = this.projectFields['verizon-options'];
    let tempTsrn = this.projectFields['tsrn'];
    let poid = this.projectFields['purchase-order-issue-date'];
    let podd = this.projectFields['purchase-order-delivery-date'];
    let prdd = this.projectFields['promise-delivery-date'];

    this.verizonFieldsForm = this.formBuilder.group({
      'verizon-options': [{value: vrznOption && vrznOption.Value ? vrznOption.Value : '', disabled: !this.isTesscoAdmin}],
      'tsrn': [{value: tempTsrn && tempTsrn.Value ? tempTsrn.Value : '', disabled: !this.isTesscoAdmin}],
      'purchase-order-delivery-date': [{value: podd && podd.Value ? podd.Value : '', disabled: !this.isTesscoAdmin}, {validators: Validators.pattern(this.VERIZON_DATE_FORMAT_REGEX), updateOn: 'blur'}],
      'purchase-order-issue-date': [{value: poid && poid.Value ? poid.Value : '', disabled: !this.isTesscoAdmin}, {validators: Validators.pattern(this.VERIZON_DATE_FORMAT_REGEX), updateOn: 'blur'}],
      'promise-delivery-date': [{value: prdd && prdd.Value ? prdd.Value : '', disabled: !this.isTesscoAdmin}, {validators: Validators.pattern(this.VERIZON_DATE_FORMAT_REGEX), updateOn: 'blur'}]
    });
    this.verizonFields = this.verizonFieldsForm.value;
    this.verizonFieldsForm.valueChanges
        .debounceTime(2000)
        .subscribe(form => {
          if (this.verizonFieldsForm.valid) {
            const fieldsUpdated = this.getUpdatedFields(form, this.verizonFields);
            this.verizonFields = form;
            forkJoin(
              fieldsUpdated.map(field =>
                this.preferencesService.setPreference('WORKSHEET', this.worksheet.id, field.code, { Value: field.value })
            ))
            .subscribe(result => {
              this.onUpdateSuccess('Worksheet preference saved!!!');
            });
          }
        });
  }

  getUpdatedFields(form: any, original: any) {
    const fields = [];
    for (const key in form) {
      if (original[key] !== form[key]) {
        const changedField = {
          code: key,
          value: form[key]
        };
        fields.push(changedField);
      }
    }
    return fields;
  }

  setPurchasePlan(accountNumber: string, purchasePlanCode: string) {
    if (accountNumber && purchasePlanCode !== null) {
      this.productAliasService.getWorksheetPurchasePlan(accountNumber, purchasePlanCode).subscribe(purchasePlan => {
        this.selectedPurchasePlan = purchasePlan;
        this.noPurchasePlan = false;
      });
    } else {
      this.selectedPurchasePlan = null;
      this.noPurchasePlan = true;
    }
  }

  editWorksheet() {
   this.edit = true;
   this.allowWorksheetContinue = true;
   this.quoteUpdateComplete.next(false);
   this.saveEvent.emit(true);
   this.editEvent.emit(true);
   //when edit button is clicked all messages are cleared so, clearing worksheet msgs also
   this.worksheetMessages = '';
  }

  saveChanges() {
    let poLineValidation : boolean = this.updateBulkPOLineNumberDetails();
   if(poLineValidation){
    this.saveButtonEvent = true;
    this.edit = false;
    this.editEvent.emit(false);
    this.bomTableService.worksheetSaveClicked.next(true);
    this.bomTableService.getBomLines(this.bomId)
      .subscribe(data => {
        this.bomLines = data;
        let cableCutQuantityFlag = false;
        let partNumber;
        if (this.bomLines.length) {
          for (const bomLine of this.bomLines) {
            if(bomLine.cableCuts && bomLine.cableCuts.length > 0){
              let totalQuantity = 0;
              for (const cableCut of bomLine.cableCuts) {
                totalQuantity += (cableCut.length * cableCut.quantity);
              }
              if(bomLine.quantity !== totalQuantity) {
                partNumber = bomLine.partNumber
                cableCutQuantityFlag = true;
                break;
              }
            }
          }
          if (cableCutQuantityFlag) {
            this.onQuantityError("Cable cuts and Quantity mismatch for partnumber " + partNumber);
            this.edit = true;
            this.editEvent.emit(true);
          } else {
            // this.bomTableService.cleanMessages();
            if( this.worksheet.approvalStatus === 'APPROVED') {
              this.projectService.resubmitForApproval(this.worksheetId).subscribe(worksheet => {
                this.worksheet = worksheet;
              });
            } else if (this.worksheet.approvalStatus === 'PENDING_APPROVAL' && this.isVerizonClient) {
              this.projectService.sendWorksheetBomChangesNotification(this.worksheetId).subscribe();
            }
          }
        }else if (this.bomLines.length === 0) {
          this.edit = true;
          this.editEvent.emit(true);
        }else {
          // this.bomTableService.cleanMessages();
          if( this.worksheet.approvalStatus === 'APPROVED') {
            this.projectService.resubmitForApproval(this.worksheetId).subscribe(worksheet => {
              this.worksheet = worksheet;
            });
          } else if (this.worksheet.approvalStatus === 'PENDING_APPROVAL' && this.isVerizonClient) {
            this.projectService.sendWorksheetBomChangesNotification(this.worksheetId).subscribe();
          }
        }
        this.worksheetBomData.next(data);
      });
    }
  }

  submitForApproval(isResubmit?: boolean) {
    if (isResubmit) {
      this.submittingApproval = true;
      this.projectService.resubmitForApproval(this.worksheet.id).subscribe(worksheet => {
        this.submittingApproval = false;
        this.submittedForApproval = true;
        this.worksheet = worksheet;
      }, error => {
        const err = error.error;
        this.errorToastr(err.message);
        this.submittingApproval = false;
        this.submittedForApproval = false;
      });
    } else {
      if (this.specialSelected === 'Verizon eQuote' && !this.worksheet.project.reca) {
        const modalRef = this.modalService.open(ConfirmationModalComponent, {
          backdrop: 'static',
          keyboard: false
        });
        modalRef.componentInstance.headerMsg = "Confirmation!";
        modalRef.componentInstance.bodyMsg = `This project is not REC(A) project. Would you like to continue?`;
        modalRef.componentInstance.primaryButtonText = "Yes, Proceed";
        modalRef.componentInstance.fn = () => {
          modalRef.close();
          this.submitForApprovalServiceCall();
        }
      } else {
        this.submitForApprovalServiceCall();
      }
    }
  }

  submitForApprovalServiceCall() {
    this.submittingApproval = true;
    this.projectService.submitForApprovalV2(this.worksheet.id).subscribe(worksheet => {
      this.submittingApproval = false;
      this.submittedForApproval = true;
      this.worksheet = worksheet;
      if (this.isVerizonClient || this.isStandardClient) {
        this.projectService.canRetractWorksheet(this.worksheetId).subscribe(result => {
          this.canRetractWorksheet = result;
        });
      }
      this.isTesscoAdmin ? this.canApproveDeny = true : this.setValueOfCanApproveOrDeny(worksheet);
    }, error => {
      const err = error.error;
      this.errorToastr(err.message);
    });
  }

  private errorToastr(error: string) {
    this.toastr.error(error, 'Error!', {
      timeOut: 5000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onUpdateSuccess(message: string) {
    this.toastr.success(message, 'Succcess!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  private warningToastr(message: string) {
    this.toastr.warning(message, 'Failed!', {
      timeOut: 5000,
      positionClass: 'toast-bottom-right'
    });
  }

  submitForQuote() {
    if (this.isVerizonClient) {
      if (this.isTesscoAdmin && this.worksheet.approvalStatus !== 'DENIED_BY_TESSCO') {
        this.router.navigate(['/quote-process', { outlets: { 'quote-process-content': ['product-advisories', this.worksheet.id] } }]);
      } else if (this.worksheet.approvalStatus === 'APPROVED' || this.worksheet.approvalStatus === 'DENIED_BY_TESSCO') {
        this.submittingApproval = true;
        const quote =  new QuoteRequest();
        quote.worksheetId = this.worksheetId;
        quote.shipViaOption = this.quoteResponse.orderOption.shipViaCode;
        quote.packingListLocation = this.quoteResponse.orderOption.packingListLocation;
        quote.invoiceLocation = this.quoteResponse.orderOption.invoiceLocation;
        if (this.quoteResponse.orderOption.isPackingListPriced === 'true') {
          quote.isPackingListPriced = Boolean(this.quoteResponse.orderOption.isPackingListPriced);
        } else {
          quote.isPackingListPriced = Boolean(0);
        }
        quote.packingListCopiesCount = +this.quoteResponse.orderOption.packingListCopiesCount;
        //here actual quote is not invoked, make the value as false if actual quote needs to invoked
        quote.forceSimulation = true;
        this.projectService.submitForTesscoReviewV2(this.worksheet.id, quote).subscribe(worksheet => {
          this.worksheet = worksheet;
          this.submittedForApproval = true;
          this.submittingApproval = false;
          if (!this.isTesscoAdmin) {
            this.tesscoReviewSubmitted = true;
          }
        }, error => {
          const err = error.error;
          this.errorToastr(err.message);
          this.submittedForApproval = true;
          this.submittingApproval = false;
          this.tesscoReviewSubmitted = false;
        });
      }
    } else {
      this.router.navigate(['/quote-process', { outlets: { 'quote-process-content': ['product-advisories', this.worksheet.id] } }]);
    }
  }

  isQuoteBlocked() {
    return this.bomTableService.isCheckoutBlocked();
  }

  openReasonModal(type: string, tier?:number) {
    this.loading = true;
    const modalRef = this.modalService.open(ApproverReasonComponent, {
      backdrop : 'static',
      keyboard : false
    });
    modalRef.componentInstance.type = type;
    const approvalId = (tier === 2) ? this.worksheet.approvalIdTierTwo : this.worksheet.approvalId;
    modalRef.result.then(approvalReasonResponse => {
      if (type === 'Approved') {
        this.approvalService.approveV2(approvalId, approvalReasonResponse.reason).subscribe(() => {
          this.loading = false;
          // this.worksheet.approvalStatus = 'APPROVED';
          (tier === 2) ? (this.worksheet.approvalStatusTierTwo = 'APPROVED') : this.worksheet.approvalStatus = 'APPROVED';

          if (approvalReasonResponse.reason) {
            this.commentsAdapterService.createComment(approvalReasonResponse.reason, false, null, [], type).subscribe(comment => {
              this.commentsAdapterService.getCommentsTree(`WORKSHEET~${this.bomId}`, this.isTesscoAdmin)
                .subscribe(comments => this.comments = comments);
            });
          }
        });
      } else if (type === 'Declined') {
        this.approvalService.deny(approvalId, approvalReasonResponse.reason).subscribe(() => {
          this.loading = false;
          this.worksheet.approvalStatus = 'DENIED';
          this.canShowResubmitForApprovalButton();
          if (approvalReasonResponse.reason) {
            this.commentsAdapterService.createComment(approvalReasonResponse.reason, false, null, [], type).subscribe(comment => {
              this.commentsAdapterService.getCommentsTree(`WORKSHEET~${this.bomId}`, this.isTesscoAdmin)
                .subscribe(comments => this.comments = comments);
            });
          }
        });
      } else if (type === 'Tessco_Declined') {
        this.projectService.denyTesscoReview(this.worksheet.id, approvalReasonResponse).subscribe(worksheet => {
          this.worksheet = worksheet;
          if (approvalReasonResponse.reason) {
            this.commentsAdapterService.createComment(approvalReasonResponse.reason, false, null, [], type).subscribe(comment => {
              this.commentsAdapterService.getCommentsTree(`WORKSHEET~${this.bomId}`, this.isTesscoAdmin)
                .subscribe(comments => this.comments = comments);
            });
          }
        });
      }
    }).catch(() => {
      this.loading = false;
    });
  }

  canShowResubmitForApprovalButton(){
    this.showResubmitButton = false;
    if(this.authService.getUserId() === this.worksheet.initiatorId){
      this.showResubmitButton = true;
    }
  }

  editWorksheetInfo() {
    const modalRef = this.modalService.open(OrderCreateComponent, {
      size: 'lg',
      backdrop : 'static',
      keyboard : false
    });
    modalRef.componentInstance.worksheet = this.worksheet;
    modalRef.componentInstance.project = this.worksheet.project;
    modalRef.componentInstance.action = 'Update';

    modalRef.result.then(() => {}).catch(() => {});
  }

  private onQuantityError(error: string) {
    this.toastr.error(error, 'Please confirm Cable Cuts!', {
      timeOut: 8000,
      positionClass: 'toast-bottom-right'
    });
  }

  onQuoteSubmitComplete($event) {
    this.saveEvent.emit(false);
    if(this.saveButtonEvent && this.worksheet.approvalStatus === 'APPROVED') {
      this.projectService.resubmitForApproval(this.worksheetId).subscribe(worksheet => {
        this.saveButtonEvent = false;
        this.worksheet = worksheet;
        this.quoteUpdateComplete.next($event);
      });
    } else {
      this.quoteUpdateComplete.next($event);
    }
  }

  onWorksheetUpdate(worksheet: Worksheet) {
    this.worksheet = worksheet;
    this.setPurchasePlan(this.accountNumber, this.worksheet.worksheetPurchasePlanCode);
  }

  dismissErrorMessage() {
    this.errorMessage = [];
  }

  worksheetContinueFlag(worksheetContinueFlag: boolean) {
    this.allowWorksheetContinue = worksheetContinueFlag;
  }

  getAllowWorksheetContinueFlag() {
    return this.allowWorksheetContinue;
  }

  submitEquote(){
    this.equoteResponse = true;
    let dropdownValue = this.verizonFieldsForm.get('verizon-options').value;

    let tsrnValue = "NA";
    if(this.verizonFieldsForm.get('tsrn').value){
      tsrnValue = this.verizonFieldsForm.get('tsrn').value;
    }

    this.projectService.submitEQuote(this.worksheet.id, dropdownValue, tsrnValue)
    .subscribe(() => {
      this.equoteResponse = false;
    }, error => {
      console.log("ERROR::: " + JSON.stringify(error));
      if(error instanceof HttpErrorResponse) {
        this.equoteResponse = false;
        if(error.status === 200) {
          this.onUpdateSuccess("Successully submitted the eQuote!!");
        } else {
          this.errorToastr("eQuote Submission Failed!! " + error.error.message);
        }
      }
    });
  }

  retractWorksheet() {
    const modalRef = this.modalService.open(ConfirmationModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.headerMsg = "Retract Confirmation!";
    modalRef.componentInstance.bodyMsg = `Are you sure you want to retract the Worksheet <strong>${ this.worksheet.siteName }</strong>?`;
    modalRef.componentInstance.primaryButtonText = "Yes, Proceed";

    modalRef.componentInstance.fn = () => {
      this.projectService.retractWorksheet(this.worksheetId).subscribe(() => {
        modalRef.close();
        this.onUpdateSuccess('Worksheet retract');
         this.submittedForApproval = false;
        this.projectService.getWorksheet(this.worksheetId).subscribe(worksheet => {
          this.worksheet = worksheet;
          this.getBomLines();
        });
        this.projectService.canRetractWorksheet(this.worksheetId).subscribe(result => {
          this.canRetractWorksheet = result;
        });
      }, error => {
        modalRef.close();
        this.warningToastr('Worksheet retract');
      });
      this.canRetractWorksheet = false;
    };
  }

  resubmitForQuote() {
    this.submittingApproval = true;
    if ((this.isVerizonClient || this.isStandardClient) && this.isTesscoAdmin) {
      const quote =  new QuoteRequest();

      quote.worksheetId = this.worksheetId;
      quote.shipViaOption = this.quoteResponse.orderOption.shipViaCode;
      quote.packingListLocation = this.quoteResponse.orderOption.packingListLocation;
      quote.invoiceLocation = this.quoteResponse.orderOption.invoiceLocation;
      quote.isCustomDelivery = this.quoteResponse.orderOption.isCustomDelivery;
      
      if (this.quoteResponse.orderOption.isPackingListPriced === 'true') {
        quote.isPackingListPriced = Boolean(this.quoteResponse.orderOption.isPackingListPriced);
      } else {
        quote.isPackingListPriced = Boolean(0);
      }
      quote.packingListCopiesCount = +this.quoteResponse.orderOption.packingListCopiesCount;
      quote.isRealQuote = true;
      this.projectService.submitQuoteV2(quote).subscribe(() => {
        this.onUpdateSuccess('Quote Resubmitted Successfully.');
        this.submittingApproval = false;
      }, error => {
        this.submittingApproval = false;
        this.warningToastr("Quote Resubmission Failed.");
      });
    } else {
      this.submittingApproval = false;
      this.warningToastr("You don't have permission to resubmit quote.");
    }
  }

  deleteWorksheet() {
    const modalRef = this.modalService.open(DeleteModalComponent, {
      backdrop: 'static',
      keyboard: false
    });

    modalRef.componentInstance.bodyMsg = `Are you sure you want to delete the Worksheet <strong>${ this.worksheet.siteName }</strong> ?`;
    modalRef.componentInstance.fn = () => {
      this.worksheets.push(this.worksheetId);
      this.projectService.deleteWorksheets(this.worksheets, this.worksheet.project.marketId).subscribe(data => {
        modalRef.close();
        this.onUpdateSuccess('Worksheets deleted sucessfully!!!');
        this.goBack();
      }, error => {
        modalRef.close();
        this.errorToastr('Worksheets could not be deleted. Please ensure that you are having permission.!!!');
      });

    };
  }

  disableEQuoteButton() {
    if (!this.verizonFieldsForm.get('verizon-options').value
          || this.verizonFieldsForm.get('verizon-options').value.trim().length === 0
          || !this.verizonFieldsForm.get('tsrn').value
          || this.verizonFieldsForm.get('tsrn').value.trim().length === 0) {
      return true;
    }
    return false;
  }

  goBack(){
    this.location.back();
  }

  approveCheckoutAndSubmitForTesscoReview() {
    this.router.navigate(['/quote-process', { outlets: { 'quote-process-content': ['product-advisories', this.worksheet.id] } }]);
  }

  poLineNumberDetails(bomeLineDetails: BomLineInput[]) {
    //check for duplicate po line numbers
    this.bomLinesPOLineNumberDetails = bomeLineDetails;
  }
  
  public updateBulkPOLineNumberDetails(): boolean {
    let isValid: boolean;
    if (this.bomLinesPOLineNumberDetails.length) {
      let poLineNumbers: number[];
      poLineNumbers = this.bomLinesPOLineNumberDetails.filter(bomline => bomline.poLineNumber > 0)
                      .map(bomline => bomline.poLineNumber);
      let duplicates = poLineNumbers.filter((s => v => s.has(v) || !s.add(v))(new Set));
      if (duplicates.length) {
        this.dismissErrorMessage();
        let message = "Worksheet contains duplicate PO Line Numbers i.e [" + duplicates + "]. Please enter unique PO Line Numbers";
        this.edit = true;
        this.editEvent.emit(true);
        this.errorMessage.push(message);
        isValid = false;
      } else {
        this.projectService.updateBomLinesPOLineNumbers(this.bomLinesPOLineNumberDetails).subscribe();
        isValid = true;
        this.dismissErrorMessage();
      }
    } else {
      isValid = true;
    }
    return isValid;
  }

  refreshCommentInWs(event: string) {
    this.commentsAdapterService.getCommentsTree(`WORKSHEET~${this.bomId}`, this.isTesscoAdmin)
      .subscribe(comments => {
        this.comments = comments;
      });
  }


  ngOnDestroy(): void {
    this.orderServiceDubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/order-worksheet/worksheet/worksheet.component.ts